<template>
  <div id="main_div">
    <section class="list-product">
      <!-- Container untuk sidebar dan content -->
      <transition name="fade-slide">
        <div class="main-container">
          <!-- Sidebar -->
          <transition name="fade">
            <div class="sidebar">
              <b-form-group>
                <h4 class="filter-title mb-2 mt-5">Cari Produk</h4>
                <b-form-input
                  v-model="filters.search"
                  @input="applyFilters"
                  placeholder="Masukkan nama produk"
                  class="filter-select no-bg custom-size-1"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <h4 class="filter-title mt-2">Jenis Produk</h4>
                <b-form-select
                  v-model="filters.category"
                  :options="[{ value: 0, text: 'Semua' }, ...navlist]"
                  @change="applyFilters"
                  class="filter-select no-bg"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <h4 class="filter-title mt-2">Jenis Tabungan</h4>
                <b-form-select
                  v-model="filters.subcategory"
                  :options="[{ value: 0, text: 'Semua' }, ...subcategoryList]"
                  @change="applyFilters"
                  class="filter-select"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <h4 class="filter-title mt-2">Setoran Awal</h4>
                <b-form-select
                  v-model="filters.setoran_awal"
                  :options="[{ value: 0, text: 'Semua' }, ...setoranAwalList]"
                  @change="applyFilters"
                  class="filter-select"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <h4 class="filter-title mt-2">Jenis Mitra</h4>
                <b-form-select
                  v-model="filters.jenis_mitra"
                  :options="[{ value: 0, text: 'Semua' }, ...jenisMitraList]"
                  @change="applyFilters"
                  class="filter-select no-bg"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <h4 class="filter-title mt-2">Provinsi</h4>
                <b-form-select
                  v-model="filters.provinsi"
                  :options="[{ value: 0, text: 'Semua' }, ...provinsiList]"
                  @change="applyFilters"
                  class="filter-select"
                ></b-form-select>
              </b-form-group>
              <b-form-group>
                <h4 class="filter-title mt-2">Kota</h4>
                <b-form-select
                  v-model="filters.kota"
                  :options="[{ value: 0, text: 'Semua' }, ...kotaList]"
                  @change="applyFilters"
                  class="filter-select mb-5"
                ></b-form-select>
              </b-form-group>
            </div>
          </transition>

          <!-- Product Cards -->
          <transition name="fade">
            <div class="content">
              <transition name="fade">
                <div v-if="isLoading" class="loading-animation">
                  <div class="spinner"></div>
                </div>
              </transition>
              <transition name="fade" mode="out-in">
                <div
                  v-if="!isLoading && items.length === 0"
                  class="text-center m-5"
                >
                  <h5>Produk tidak ditemukan.</h5>
                </div>
                <div v-else class="product-cards">
                  <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="product-card hover-effect row"
                  >
                    <div
                      style="background-color: #f0f0f0;"
                      class="col-12 col-md-4 col-lg-12 col-xl-3 px-0 d-flex justify-content-center"
                    >
                      <b-img
                        left
                        :src="getImageUrl(item)"
                        rounded
                        class="object-fit-cover product-image"
                        alt="Product image"
                      ></b-img>
                    </div>
                    <div class="col-12 col-md-8 col-lg-12 col-xl-9">
                      <div class="row justify-content-start px-2">
                        <div class="col-md-6 col-lg-6 mt-2">
                          <h4 class="product-title">
                            {{
                              item.mitra.mitra_contact
                                .nama_organisasi_perusahaan
                            }}
                          </h4>
                          <span class="product-subtitle">
                            {{ item.nama_produk }}
                          </span>
                        </div>
                        <div class="col-md-6 col-lg-6 mt-2">
                          <h4 class="product-price">
                            Setoran Awal: <small>mulai dari</small>
                            {{
                              new Intl.NumberFormat().format(
                                item.min_initial_deposit
                              )
                            }}
                          </h4>
                        </div>
                      </div>
                      <div class="row custom-gap">
                        <div class="col-md-6 col-xl-12 mt-2">
                          <b-card-text class="product-description-funding">
                            {{ item.description }}
                          </b-card-text>
                          <b-card-text class="product-category">
                            {{ item.sub_product_category.name }}
                          </b-card-text>
                        </div>
                        <div
                          class="col-md-5 col-xl-12 mt-2"
                          v-if="item.nisbah || item.equal_rate"
                        >
                          <b-card-text>
                            <h4 class="product-details" v-if="item.nisbah">
                              Nisbah: {{ item.nisbah }}
                            </h4>
                            <h4 class="product-details" v-if="item.equal_rate">
                              Proyeksi Bagi Hasil (Equal Rate):
                              {{ $formatPersen(item.equal_rate) }}%
                            </h4>
                          </b-card-text>
                        </div>
                        <div class="col-md-12">
                          <span
                            v-if="item.automatic_roll_over"
                            style="background-color: #274C8F; font-weight: 500; color: #F6BC3C; padding: 5px 10px; border-radius: 10px; font-size: 0.875rem; display: inline-block;"
                          >
                            ARO
                          </span>
                          <span
                            style="background-color: #F6BC3C; font-weight: 500; color: #274C8F; padding: 5px 10px; border-radius: 10px; font-size: 0.875rem; display: inline-block;"
                          >
                            {{ item.akad.name }}
                          </span>
                          <span
                            style="background-color: #E0E0E0; font-weight: 500; color: #333; padding: 5px 10px; border-radius: 10px; font-size: 0.875rem; display: inline-block;"
                          >
                            {{ item.mitra.mitra_profile.kotaNama }}, {{ item.mitra.mitra_profile.provinsiNama }}
                          </span>
                        </div>
                      </div>
                      <div class="row justify-content-end custom-gap mt-10 col">
                        <div
                          class="float-center float-md-right mb-2 mb-md-0 mt-2"
                        >
                          <a
                            :href="'detail-produk/' + item.id"
                            class="text-primary hover-underline"
                            >Lihat Detail</a
                          >
                          <b-modal
                            size="sm"
                            v-model="confirmPengajuanModalStep2"
                            hide-footer
                            hide-header
                          >
                            <div class="d-block text-center">
                              <h3 :class="textColor">{{ modalTitle }}</h3>
                              <h3 :class="textColor">{{ modalText }}</h3>
                            </div>
                            <div class="row">
                              <div class="col">
                                <b-button
                                  class="mt-3"
                                  block
                                  @click="confirmAddPengajuan(item)"
                                  >Ya</b-button
                                >
                              </div>
                              <div class="col">
                                <b-button
                                  class="mt-3"
                                  block
                                  @click="confirmPengajuanModalStep2 = false"
                                  >Tidak</b-button
                                >
                              </div>
                            </div>
                          </b-modal>
                          <b-modal
                            size="md"
                            v-model="confirmPengajuanModalStep1"
                            hide-footer
                            hide-header
                          >
                            <div class="d-block text-center">
                              <h3 :class="textColor">
                                Silahkan Masukkan Nominal Setoran Awal
                              </h3>
                              <h3 :class="textColor">
                                Setoran minimal anda adalah Rp.
                                {{
                                  new Intl.NumberFormat().format(minimSetoran)
                                }}
                              </h3>
                              <b-form-input
                                id="setoran_awal_user"
                                v-model="setoran_awal_user"
                                placeholder="Masukkan Setoran Awal"
                                class="text-center"
                                v-currency
                              ></b-form-input>
                            </div>
                            <div class="row">
                              <div class="col">
                                <b-button
                                  class="mt-3"
                                  block
                                  @click="confirmAddPengajuan(item)"
                                  >Ajukan</b-button
                                >
                              </div>
                              <div class="col">
                                <b-button
                                  class="mt-3"
                                  block
                                  @click="confirmPengajuanModalStep1 = false"
                                  >Batal</b-button
                                >
                              </div>
                            </div>
                          </b-modal>
                        </div>
                        <b-button
                          v-if="currentUser && currentUser.info.role_id != 5"
                          variant="primary"
                          @click="addPengajuan(item.id)"
                          class="float-right"
                        >
                          Ajukan Sekarang
                        </b-button>
                      </div>
                    </div>
                  </div>
                  <div class="m-auto flex justify-center items-center">
                    <b-button
                      @click="setPage(summaryPage.current_page - 1)"
                      :disabled="summaryPage.current_page === 1"
                      class="rounded-md px-4 py-2"
                      :style="{ backgroundColor: '#274C8F', color: '#F6BC3C' }"
                    >
                      Sebelumnya
                    </b-button>
                    <span class="px-4 py-2">
                      Halaman {{ summaryPage.current_page }} dari
                      {{ summaryPage.last_page }}
                    </span>
                    <b-button
                      @click="setPage(summaryPage.current_page + 1)"
                      :disabled="
                        summaryPage.current_page === summaryPage.last_page
                      "
                      class="rounded-md px-4 py-2"
                      :style="{ backgroundColor: '#274C8F', color: '#F6BC3C' }"
                    >
                      Selanjutnya
                    </b-button>
                  </div>
                </div>
              </transition>
            </div>
          </transition>
        </div>
      </transition>
      <b-modal
        size="sm"
        v-model="successPengajuanModal"
        hide-footer
        hide-header
      >
        <div class="d-block text-center">
          <h3 :class="textColor">{{ modalTitle }}</h3>
          <h3 :class="textColor">{{ modalText }}</h3>
        </div>
        <b-button class="mt-3" block @click="successPengajuanModal = false"
          >Tutup</b-button
        >
      </b-modal>
      <b-modal size="m" v-model="notfulfillModal">
        <div class="d-block text-center">
          <h3><strong>Profil Belum Lengkap</strong></h3>
          <h4 class="font-weight-light">
            Silahkan lengkapi profil Anda Terlebih Dahulu !
          </h4>
        </div>
        <!-- <b-button class="mt-3" block @click="notfulfillModalKlik">Oke</b-button> -->
        <template #modal-footer>
          <!-- <b-button @click="handleCancel" variant="secondary">Batal</b-button> -->
          <b-button @click="notfulfillModalKlik" variant="primary"
            >Oke</b-button
          >
        </template>
      </b-modal>
    </section>
    <div class="row">
      <div class="col-md-12 text-center">
        <p>© <span id="year"></span> efunding.id. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Product from "../api/produk";
import Pengajuan from "../api/pengajuan";
import ProductCategory from "../api/productcategory";
import SubProductCategory from "../api/subproductcategory";
import SetoranAwal from "../api/setoranawal";
import JenisNasabah from "../api/jenisnasabah";
import JenisMitra from "../api/jenismitra";
import Provinsi from "../api/daerahindonesia/provinsi";
import Kota from "../api/daerahindonesia/kota";

export default {
  name: "ListProduk",
  beforeCreate() {
    document.body.className = "";
  },
  data() {
    return {
      items: [],
      navlist: [],
      subcategoryList: [],
      setoranAwalList: [],
      jenisNasabahList: [],
      jenisMitraList: [],
      provinsiList: [],
      kotaList: [],
      summaryPage: {
        current_page: null,
        first_page_url: null,
        from: null,
        last_page: null,
        last_page_url: null,
        next_page_url: null,
        path: null,
        per_page: null,
        prev_page_url: null,
        to: null,
        total: null
      },
      filters: {
        search: "",
        category: null,
        subcategory: null,
        setoran_awal: null,
        jenis_mitra: null,
        provinsi: null,
        kota: null
      },
      form: {
        product_id: null,
        mitra_id: null,
        funder_id: null,
        setoran_awal: null
      },
      isLoading: false,
      successPengajuanModal: false,
      notfulfillModal: false,
      confirmPengajuanModal: false,
      modalTitle: "",
      product_id: "",
      funder_id: "",
      mitra_id: "",
      modalText: "",
      textColor: "",
      productImage: "",
      currentUser: null,
      role_id: "",
      confirmPengajuanModalStep1: false,
      confirmPengajuanModalStep2: false,
      setoran_awal_user: null,
      minimSetoran: 0,
      provinsiCache: {},
      kotaCache: {}
    };
  },
  directives: {
    currency: {
      bind(el, binding, vnode) {
        el.addEventListener("input", () => {
          let value = el.value.replace(/\D/g, "");
          if (value) {
            value = parseInt(value).toLocaleString("id-ID", {
              style: "currency",
              currency: "IDR",
              minimumFractionDigits: 0
            });
            el.value = value;
            vnode.componentInstance.$emit("input", value);
          } else {
            vnode.componentInstance.$emit("input", "");
          }
        });
      }
    }
  },
  created() {
    if (this.$store.state.auth.user) {
      this.currentUser = this.$store.state.auth.user;
    } else {
      this.currentUser = null;
    }
    this.initializeFiltersFromQuery();
  },
  mounted() {
    document.getElementById("year").textContent = new Date().getFullYear();
    this.loadData();
    this.categoryList();
    this.subCategoryList();
    this.setoranAwal();
    this.jenisNasabah();
    this.jenisMitra();
    this.loadProvinsi();
  },
  watch: {
    "$route.query.category"(newCategory) {
      this.loadData();
    }
  },
  methods: {
    async getProvinsi(id) {
      if (!id) return "Tidak ditemukan";

      if (this.provinsiCache[id]) {
        return this.provinsiCache[id];
      }

      try {
        const res = await Provinsi.show(id);
        this.provinsiCache[id] = res.data.nama;
        return res.data.nama;
      } catch (error) {
        console.error("Gagal mengambil provinsi:", error);
        return "Tidak ditemukan";
      }
    },
    async getKota(id) {
      if (!id) return "Tidak ditemukan";

      if (this.kotaCache[id]) {
        return this.kotaCache[id];
      }

      try {
        const res = await Kota.show(id);
        this.kotaCache[id] = res.data.nama;
        return res.data.nama;
      } catch (error) {
        console.error("Gagal mengambil kota:", error);
        return "Tidak ditemukan";
      }
    },
    async loadAlamat() {
      for (const item of this.items) {
        if (item.mitra.mitra_profile) {
          item.mitra.mitra_profile.provinsiNama = await this.getProvinsi(item.mitra.mitra_profile.provinsi);
          item.mitra.mitra_profile.kotaNama = await this.getKota(item.mitra.mitra_profile.kota);
        }
      }
    },
    async loadData() {
      this.isLoading = true;
      try {
        const query = { ...this.$route.query, page: this.$route.query.page || 1 };

        if (this.currentUser) {
          this.role_id = this.currentUser.info.role_id;
        } else {
          this.role_id = null;
        }

        if (this.role_id === 3) {
          query.jenis_nasabah = 1;
        } else if (this.role_id === 4) {
          query.jenis_nasabah = 2;
        }

        const res = await Product.index(query);
        this.items = res.data.data.data;
        this.productImage = process.env.API_URL;
        this.summaryPage = {
          current_page: res.data.data.current_page,
          last_page: res.data.data.last_page,
          per_page: res.data.data.per_page,
          total: res.data.data.total
        };

        await this.loadAlamat();
      } catch (error) {
        console.error("Gagal mengambil data produk:", error);
      } finally {
        this.isLoading = false;
      }
    },
    notfulfillModalKlik() {
      this.notfulfillModal = false;
      this.$router.push("/pengajuan-saya?q=Profil");
    },
    setPage(page) {
      if (page >= 1 && page <= this.summaryPage.last_page) {
        this.$router
          .push({ query: { ...this.$route.query, page } })
          .then(() => {
            this.loadData();
          });
      }
    },
    categoryList() {
      ProductCategory.index()
        .then(res => {
          this.navlist = res.data.data.map(category => ({
            value: category.id,
            text: category.name
          }));
        })
        .catch(err => console.log(err));
    },
    confirmAddPengajuan(item) {
      if (
        parseInt(this.setoran_awal_user.replace(/\D/g, "")) <
        parseInt(this.minimSetoran)
      ) {
        this.handleFailedPengajuan(
          "Anda harus mengisi nominal setoran awal yang setara atau lebih besar dari setoran minimal"
        );
      } else {
        this.form.product_id = this.product_id;
        this.form.mitra_id = this.mitra_id;
        this.form.funder_id = this.funder_id;
        this.form.setoran_awal = parseInt(
          this.setoran_awal_user.replace(/\D/g, "")
        );
        if (
          this.currentUser.info.role_id === 4 ||
          this.currentUser.info.role_id === 3
        ) {
          this.submitPengajuan();
        } else {
          this.handleNonFunderRole();
        }
      }
    },
    handleFailedPengajuan(message) {
      this.confirmPengajuanModalStep1 = false;
      this.setoran_awal_user = null;
      this.successPengajuanModal = true;
      this.modalTitle = "Pengajuan gagal dilakukan";
      this.modalText = message;
      this.textColor = "text-danger";
    },
    submitPengajuan() {
      Pengajuan.store(this.form)
        .then(res => {
          this.handlePengajuanResponse(res.data.meta);
        })
        .catch(err => console.log(err));
    },
    handlePengajuanResponse(meta) {
      this.confirmPengajuanModalStep1 = false;
      this.setoran_awal_user = null;
      if (meta.code === 200) {
        this.modalTitle = "Pengajuan berhasil dilakukan";
        this.modalText = "Tim kami akan segera menghubungi anda";
      } else {
        this.modalTitle = "Pengajuan gagal dilakukan";
        this.modalText = meta.messages || "Terjadi kesalahan";
        this.textColor = "text-danger";
      }
      this.successPengajuanModal = true;
    },
    handleNonFunderRole() {
      if (
        this.currentUser.info.role_id === 2 ||
        this.currentUser.info.role_id === 5
      ) {
        this.modalTitle = "Pengajuan hanya bisa dilakukan oleh nasabah";
        this.modalText = "Silahkan berpindah akun menjadi nasabah";
        this.successPengajuanModal = true;
      } else {
        this.$router.push("login");
      }
    },
    hrefToDetail(id) {
      this.$router.push(`/detail-produk/${id}`);
    },
    addPengajuan(id) {
      if (this.currentUser) {
        Pengajuan.getIsFillFunderData()
          .then(res => {
            if (res.data.data === "ready") {
              this.$router.push(`/detail-produk/${id}`);
              // this.product_id = item.id;
              // this.funder_id = this.currentUser.info.id;
              // this.mitra_id = item.mitra_id;
              // this.minimSetoran = item.setoranawal.nilai;

              // // Tampilkan modal konfirmasi pengajuan
              // this.confirmPengajuanModalStep1 = true;
              // this.modalTitle = "Apakah anda yakin?";
              // this.modalText = "*Anda masih bisa membatalkan pengajuan";
            } else {
              // Tampilkan modal pemberitahuan
              this.notfulfillModal = true;
              // Redirect ke /pengajuan-saya setelah 3 detik
              // setTimeout(() => {
              //   this.$router.push('/pengajuan-saya');
              // }, 3000);
            }
          })
          .catch(err => console.log(err));
      } else {
        this.$router.push("/login");
      }
    },
    subCategoryList() {
      SubProductCategory.index()
        .then(res => {
          this.subcategoryList = res.data.data.data.map(subcategory => ({
            value: subcategory.id,
            text: subcategory.name
          }));
        })
        .catch(err => console.log(err));
    },
    setoranAwal() {
      SetoranAwal.index()
        .then(res => {
          this.setoranAwalList = res.data.data.data.map(setoran => ({
            value: setoran.id,
            text: setoran.nilai
          }));
        })
        .catch(err => console.log(err));
    },
    jenisNasabah() {
      JenisNasabah.index()
        .then(res => {
          this.jenisNasabahList = res.data.data.data.map(jenis => ({
            value: jenis.id,
            text: jenis.name
          }));
        })
        .catch(err => console.log(err));
    },
    jenisMitra() {
      JenisMitra.index()
        .then(res => {
          this.jenisMitraList = res.data.data.data.map(jenis => ({
            value: jenis.id,
            text: jenis.name
          }));
        })
        .catch(err => console.log(err));
    },
    loadProvinsi() {
      Provinsi.index()
        .then(res => {
          this.provinsiList = res.data.provinsi.map(provinsi => ({
            value: provinsi.id,
            text: provinsi.nama
          }));
        })
        .catch(err => console.log(err));
    },
    loadKota(provinsiId) {
      if (provinsiId) {
        Kota.index(provinsiId)
          .then(res => {
            this.kotaList = res.data.kota_kabupaten.map(kota => ({
              value: kota.id,
              text: kota.nama
            }));
          })
          .catch(err => console.log(err));
      } else {
        this.kotaList = [];
      }
    },
    getImageUrl(item) {
      return item.mitra && item.mitra.mitra_profile
        ? this.productImage + item.mitra.mitra_profile.logo_mitra
        : "";
    },
    applyFilters() {
      this.isLoading = true;
      const query = {};

      if (this.filters.search) query.search = this.filters.search;
      if (this.filters.category) query.category = this.filters.category;
      if (this.filters.subcategory)
        query.subcategory = this.filters.subcategory;
      if (this.filters.setoran_awal)
        query.setoran_awal = this.filters.setoran_awal;
      if (this.filters.jenis_mitra)
        query.jenis_mitra = this.filters.jenis_mitra;
      if (this.filters.provinsi) {
        query.provinsi = this.filters.provinsi;
        this.loadKota(this.filters.provinsi); // Load kota based on selected provinsi
      }
      if (this.filters.kota) query.kota = this.filters.kota;

      this.$router.push({ query }).then(() => {
        this.loadData();
      });
    },
    initializeFiltersFromQuery() {
      const query = this.$route.query;
      this.filters.search = query.search || "";
      this.filters.category = query.category ? parseInt(query.category) : 0;
      this.filters.subcategory = query.subcategory
        ? parseInt(query.subcategory)
        : 0;
      this.filters.setoran_awal = query.setoran_awal
        ? parseInt(query.setoran_awal)
        : 0;
      this.filters.jenis_mitra = query.jenis_mitra
        ? parseInt(query.jenis_mitra)
        : 0;
      this.filters.provinsi = query.provinsi ? parseInt(query.provinsi) : 0;
      this.filters.kota = query.kota ? parseInt(query.kota) : 0;
    }
  }
};
</script>

<style>
body {
  margin: 0;
  font-family: "Poppins", sans-serif;
}

.list-product {
  padding: 20px;
}

.main-container {
  display: flex;
  align-items: flex-start;
  margin: 80px 280px 0;
  flex-wrap: wrap;
}

.sidebar {
  width: 250px;
  min-width: 250px;
  background-color: #274c8f;
  color: white;
  padding: 0px 20px 0px 20px;
  border-radius: 8px;
  margin-right: 20px;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.filter-title {
  font-size: 16px;
  color: #f6bc3c;
  font-weight: bold;
  text-align: center;
}

.content {
  flex: 1;
  background-color: #f9f9f9;
  border-radius: 8px;
  transition: transform 0.3s ease;
  min-width: 300px;
}

.product-cards {
  display: grid;
  grid-template-columns: 1fr;
  /* Tata letak vertikal pada layar besar */
  gap: 10px;
}

.product-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.product-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.product-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.product-subtitle {
  font-size: 15px;
  font-weight: normal;
  margin-bottom: 5px;
}

.product-description-funding {
  font-size: 13px;
  color: #555;
  margin-bottom: 5px;
}

.product-category {
  font-size: 13px;
  color: #888;
  font-weight: bold;
  margin-bottom: 5px;
}

.product-price {
  font-size: 14px;
  color: #274c8e;
  font-weight: bold;
  margin-bottom: 5px;
}

.product-details {
  font-size: 13px;
  color: #555;
  margin-bottom: 5px;
}

.loading-animation {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-top: 8px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.custom-gap {
  gap: 30px;
  padding: 10px;
}

.hover-effect {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-effect:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.hover-underline:hover {
  text-decoration: underline;
}

.custom-size-1 {
  font-size: 12.5px;
}

/* Animasi untuk Sidebar dan Konten */
@keyframes fadeSlideIn {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.fade-slide-enter-active {
  animation: fadeSlideIn 0.5s ease-out forwards;
}

.fade-enter-active {
  animation: fadeIn 0.3s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

/* Animasi Fade untuk Modals */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Responsiveness */
@media (min-width: 1201px) {
  .main-container {
    margin: 75px 200px 0;
  }
  .product-cards {
    grid-template-columns: repeat(1, minmax(250px, 1fr));
    /* Berubah menjadi horizontal */
    align-items: center;
  }

  .product-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: white;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  /* .product-card img {
    width: 100%;
    height: 50%;
    max-height: 50%;
    border-radius: 8px 8px 0 0;
    margin: auto;
  } */
  .product-image {
    min-width: 240px;
    max-width: 240px;
    height: auto;
    margin: auto;
    padding: 2rem;
  }
}

@media (max-width: 1440px) {
  .main-container {
    margin: 50px 100px 0;
  }

  .sidebar {
    width: 220px;
  }

  .content {
    margin-left: 10px;
  }

  .product-cards {
    grid-template-columns: repeat(1, minmax(250px, 1fr));
    /* Berubah menjadi horizontal */
  }
  .product-image {
    min-height: 240px;
    max-height: 240px;
    width: auto;
    margin: auto;
    padding: 2rem;
  }
}

@media (max-width: 1200px) {
  .main-container {
    margin: 50px 50px 0;
  }

  .sidebar {
    width: 200px;
  }

  .content {
    margin-left: 0;
  }

  .product-cards {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    /* Berubah menjadi horizontal */
  }
}

@media (max-width: 1024px) {
  .main-container {
    margin: 20px;
  }

  .sidebar {
    width: 100%;
    margin-bottom: 20px;
  }

  .content {
    min-width: 100%;
  }

  .product-cards {
    grid-template-columns: repeat(1, minmax(200px, 1fr));
    /* Tata letak responsif */
  }

  .product-image {
    min-height: 180px;
    max-height: 180px;
    width: auto;
    margin: auto;
    padding: 2rem;
  }
}

@media (max-width: 576px) {
  .main-container {
    margin: 10px;
  }

  .product-title {
    font-size: 16px;
  }

  .product-subtitle {
    font-size: 14px;
  }

  .product-price {
    font-size: 12px;
  }

  .product-details {
    font-size: 12px;
  }

  .product-description-funding {
    font-size: 12px;
  }

  .product-category {
    font-size: 12px;
  }

  .custom-gap {
    gap: 15px;
    padding: 5px;
  }

  .product-cards {
    grid-template-columns: 1fr;
    /* Tata letak vertikal pada layar kecil */
  }

  .product-image {
    min-height: 180px;
    max-height: 180px;
    width: auto;
    margin: auto;
    padding: 2rem;
  }
}

/* Gambar Responsif */
.product-card img {
  /* width: 100%; */
  /* Mempertahankan rasio aspek */
  border-radius: 8px 8px 0 0;
  /* Sudut membulat untuk gambar */
}
</style>



// WEBPACK FOOTER //
// src/public/list-produk.vue